import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import CourseDetail from "@/pages/CourseDetail";
import Store from "@/pages/Store";
import StoreProduct from "@/pages/StoreProduct";
import StoreSuccess from "@/pages/StoreSuccess";
import News from "@/pages/News";
import RequestService from "@/pages/RequestService";
import NewsArticle from "@/pages/NewsArticle";
import Login from "@/pages/Login";
import StaffLogin from "@/pages/StaffLogin";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Apply from "@/pages/Apply";
import Dashboard from "@/pages/learner/Dashboard";
import EnrolmentDetail from "@/pages/learner/EnrolmentDetail";
import CoursePlayer from "@/pages/learner/CoursePlayer";
import ProviderDashboard from "@/pages/provider/ProviderDashboard";
import VerifyCertificate from "@/pages/VerifyCertificate";
import { PrivacyPolicy, RefundPolicy, TermsConditions } from "@/pages/Legal";
import Account from "@/pages/Account";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/courses" element={<Shell><Catalogue /></Shell>} />
          <Route path="/courses/category/:category" element={<Shell><Catalogue /></Shell>} />
          <Route path="/courses/:id" element={<Shell><CourseDetail /></Shell>} />
          <Route path="/store" element={<Shell><Store /></Shell>} />
          <Route path="/store/success" element={<Shell><StoreSuccess /></Shell>} />
          <Route path="/store/:id" element={<Shell><StoreProduct /></Shell>} />
          <Route path="/news" element={<Shell><News /></Shell>} />
          <Route path="/business-development" element={<Shell><RequestService /></Shell>} />
          <Route path="/news/:slug" element={<Shell><NewsArticle /></Shell>} />
          <Route path="/login" element={<Shell><Login /></Shell>} />
          <Route path="/admin" element={<Shell><StaffLogin /></Shell>} />
          <Route path="/register" element={<Shell><Register /></Shell>} />
          <Route path="/verify-email" element={<Shell><VerifyEmail /></Shell>} />
          <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />
          <Route path="/reset-password" element={<Shell><ResetPassword /></Shell>} />
          <Route path="/verify-certificate/:number" element={<Shell><VerifyCertificate /></Shell>} />
          <Route path="/privacy-policy" element={<Shell><PrivacyPolicy /></Shell>} />
          <Route path="/refund-policy" element={<Shell><RefundPolicy /></Shell>} />
          <Route path="/terms" element={<Shell><TermsConditions /></Shell>} />

          <Route path="/apply/:courseId" element={<ProtectedRoute><Shell><Apply /></Shell></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Shell><Dashboard /></Shell></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><Shell><Account /></Shell></ProtectedRoute>} />
          <Route path="/enrolment/:id" element={<ProtectedRoute><Shell><EnrolmentDetail /></Shell></ProtectedRoute>} />
          <Route path="/learn/:courseId" element={<ProtectedRoute><Shell><CoursePlayer /></Shell></ProtectedRoute>} />
          <Route path="/provider" element={<ProtectedRoute roles={["provider_admin", "platform_admin", "tutor"]}><Shell><ProviderDashboard /></Shell></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
